module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "template"
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-e5c3e9c2!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/template/component.vue
// module id = 4003
// module chunks = 1